import React from 'react'
import PropTypes from 'prop-types'
import { Item } from './.'
import { CurrencyLabel } from 'Shared/CurrencyLabel'

const History = ({ totalizers: { expired, redeemed, credited }, currency }) => (
  <div className='extract-points-content'>
    <p>{`Histórico de ${currency.label}`}</p>

    <div className='extract-items'>
      <Item description={`${currency.label} expirados`} className='available-points'>
        <CurrencyLabel value={expired} {...currency} />
      </Item>
      <Item description={`${currency.label} regatados`} className='processing-points'>
        <CurrencyLabel value={redeemed} {...currency} />
      </Item>
      <Item description={`${currency.label} creditados`} className='total-points'>
        <CurrencyLabel value={credited} {...currency} />
      </Item>
    </div>
  </div>
)

History.propTypes = {
  currency: PropTypes.object.isRequired,
  totalizers: PropTypes.shape({
    expired: PropTypes.number.isRequired,
    redeemed: PropTypes.number.isRequired,
    credited: PropTypes.number.isRequired
  }).isRequired
}

export default History



// WEBPACK FOOTER //
// ./src/Participant/Extract/Totalizers/History.js